<template>
  <el-form
    :model="shopForm"
    :rules="rules"
    ref="shopForm"
    label-width="15%"
    class="shop-detail-form"
    v-loading.body="fetchLoding"
  >
    <el-collapse v-model="activeNames">
      <el-collapse-item :title="generateCustomizeString('shopRequiredInfo')" name="1">
        <el-form-item :label="generateCustomizeString('shopName')" prop="display_shop_name">
          <el-input v-model="shopForm.display_shop_name"></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('shopCustomHost')" prop="shop_custom_host">
          <div v-if="shopForm.id == 15 || shopForm.id == 774 || shopForm.id == 995 || shopForm.id == 1325">
            <el-input v-model="shopForm.shop_custom_host" style="width:300px" disabled>
              <template slot="prepend">http://</template>
            </el-input>
            <el-tag
              class="custom-host-status"
              effect="plain"
              type="success"
            >
              {{generateCustomizeString('Active')}}
            </el-tag>
          </div>
          <div v-else>
            <el-input v-model="shopForm.shop_custom_host" style="width:300px" :disabled="shopForm.configs.custom_host_status != 'Inactive'">
              <template slot="prepend">http://</template>
            </el-input>
            <el-tag
              class="custom-host-status"
              effect="plain"
              type="success"
            >
              {{generateCustomizeString(shopForm.configs.custom_host_status)}}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('shopLogo')" prop="shop_logo_url">
          <el-upload
            action="https://upload-z2.qiniup.com"
            :limit="1"
            :drag="true"
            :on-success="handleAvatarSuccess"
            :on-error="handleError"
            :before-upload="beforeAvatarUpload"
            :data="qiniuData"
          >
            <img v-if="shopForm.shop_logo_url" :src="displayLogoUrl" class="avatar" />
            <div v-else>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                {{generateCustomizeString('dragFiles')}}
                <em>{{generateCustomizeString('uploadFiles')}}</em>
              </div>
            </div>
            <div class="el-upload__tip" slot="tip">{{generateCustomizeString('fileLimit')}}</div>
          </el-upload>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item :title="generateCustomizeString('shopAdminAccount')" name="2">
        <el-form-item :label="generateCustomizeString('loginEmail')" prop="shop_admin_email">
          <el-input v-model="shopForm.employee.email" disabled></el-input>
          <!-- <el-input v-else v-model="shopForm.shop_admin_email" :disabled="editStatus"></el-input> -->
        </el-form-item>
        <el-form-item :label="generateCustomizeString('password')" prop="shop_admin_password">
          <div>
            <el-input v-model="shopForm.employee.password" type="password" disabled style="width:320px"></el-input>
            <el-button @click="resetPasswordFormVisible = true">{{ generateCustomizeString('changePassword') }}</el-button>
            <el-dialog
              :title="generateCustomizeString('editPassword')"
              :visible.sync="resetPasswordFormVisible"
            >
              <el-form :model="passwordForm" :rules="rules">
                <el-form-item :label="generateCustomizeString('oldPassword')" :label-width="formLabelWidth" prop="old_password">
                  <el-input v-model="passwordForm.old_password" type="password"></el-input>
                </el-form-item>
                <el-form-item
                  :label="generateCustomizeString('newPassword')"
                  :label-width="formLabelWidth"
                  prop="password"
                  style="padding-top: 30px;"
                >
                  <el-input v-model="passwordForm.password" type="password"></el-input>
                </el-form-item>
                <el-form-item
                  :label="generateCustomizeString('confirmPassword')"
                  :label-width="formLabelWidth"
                  prop="password_confirmation"
                  style="padding-top: 30px;"
                >
                  <el-input v-model="passwordForm.password_confirmation" type="password" style></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button
                  @click="resetPasswordFormVisible = false"
                >{{generateCustomizeString('cancelPassword')}}</el-button>
                <el-button
                  type="primary"
                  @click="resetPasswordAction"
                >{{generateCustomizeString('submitPassword')}}</el-button>
              </div>
            </el-dialog>
          </div>
          <!-- <div v-else>
            <el-input v-model="shopForm.shop_admin_password" type="password" :disabled="editStatus"></el-input>
          </div>-->
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item :title="generateCustomizeString('shopPaymentSetting')" name="3" v-if="shopForm.is_agent === false">
        <!-- IEPay MID -->
        <el-form-item
          :label="generateCustomizeString('myPayMid')"
          prop="my_pay_mid"
        >
          <el-input v-model="shopForm.my_pay_mid" style="width: 600px; margin-right: 10px;"></el-input>
          <el-popover
            :title="generateCustomizeString('getMidTitle')"
            placement="top-start"
            width="450"
            trigger="hover"
          >
            <div class="payment-setting-tips">
              <span>{{ generateCustomizeString('haveIepayAccout') }}</span>
              <a href="https://a.mypaynz.com" target="_blank" style="color: #409EFF;">https://a.mypaynz.com</a>
              <span>{{ generateCustomizeString('getMid') }}</span>
            </div>
            <el-tag slot="reference">?</el-tag>
          </el-popover>
        </el-form-item>
        <!-- IEPay API Key -->
        <el-form-item
          :label="generateCustomizeString('myPayApiKey')"
          prop="my_pay_api_key"
        >
          <el-input v-model="shopForm.my_pay_api_key" style="width: 600px; margin-right: 10px;"></el-input>
          <el-popover
            :title="generateCustomizeString('getApikeyTitle')"
            placement="top-start"
            width="450"
            trigger="hover"
          >
            <div class="payment-setting-tips">
              <span>{{ generateCustomizeString('haveIepayAccout') }}</span>
              <a href="https://a.mypaynz.com" target="_blank" style="color: #409EFF;">https://a.mypaynz.com</a>
              <span>{{ generateCustomizeString('getApikey') }}</span>
            </div>
            <el-tag slot="reference">?</el-tag>
          </el-popover>
        </el-form-item>
        <el-form-item>
          <span v-if="this.$i18n.locale == 'zh'" style="color: #606266;">
            如已配置完成店铺支付信息，可至“店铺管理”—“支付管理”，或点击
            <a href="/shop/payment-method-management" style="color: #409EFF;">{{generateCustomizeString('here')}}</a>，配置支付方式。
          </span>
          <span v-if="this.$i18n.locale == 'en'" style="color: #606266;">
            If you have completed Payment Setting, you can go to "Shop"-"Payment Management", or click
            <a href="/shop/payment-method-management" style="color: #409EFF;">{{generateCustomizeString('here')}}</a> to set payment methods.
          </span>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item :title="generateCustomizeString('shopWechatSetting')" name="4">
        <el-form-item :label="generateCustomizeString('welcomeImage')" prop="oa_welcome_image">
          <el-upload
            action="https://upload-z2.qiniup.com"
            :limit="1"
            :drag="true"
            :on-success="handleOaWelcomeAvatarSuccess"
            :on-error="handleError"
            :before-upload="beforeAvatarUpload"
            :data="qiniuData"
          >
            <img
              v-if="this.shopForm.configs.oa_welcome_image"
              :src="displayWelcomeImgUrl"
              class="avatar"
            />
            <div v-else>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                {{generateCustomizeString('dragFiles')}}
                <em>{{generateCustomizeString('uploadFiles')}}</em>
              </div>
            </div>
            <div class="el-upload__tip" slot="tip">{{generateCustomizeString('fileLimit')}}</div>
          </el-upload>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('customerServiceWxId')" prop="wechat_id">
          <el-input v-model="shopForm.wechat_id"></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('shopQr')" prop="shop_qr">
          <el-upload
            action="https://upload-z2.qiniup.com"
            :limit="1"
            :drag="true"
            :on-success="handleShopQr"
            :on-error="handleError"
            :before-upload="beforeAvatarUpload"
            :data="qiniuData"
          >
            <img v-if="this.shopForm.configs.shop_qr" :src="displayShopQr" class="avatar" />
            <div v-else>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                {{generateCustomizeString('dragFiles')}}
                <em>{{generateCustomizeString('uploadFiles')}}</em>
              </div>
            </div>
            <div class="el-upload__tip" slot="tip">{{generateCustomizeString('fileLimit')}}</div>
          </el-upload>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('contactInfo')" prop="wechat_message">
          <el-input type="textarea" autosize v-model="shopForm.wechat_message"></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('wx_appid')" prop="wx_appid">
          <el-input v-model="shopForm.wx_appid" disabled></el-input>
        </el-form-item>
        <!-- <el-form-item
          :label="generateCustomizeString('wx_secret')"
          prop="wx_secret"
        >
          <el-input
            v-model="shopForm.wx_secret"
            disabled
          ></el-input>
        </el-form-item>-->
        <el-form-item :label="generateCustomizeString('oa_token')" prop="oa_token">
          <el-input v-model="shopForm.oa_token" disabled></el-input>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item :title="generateCustomizeString('shopCustomizationSetting')" name="5">
        <el-form-item label="GST Number" prop="gst_no">
          <el-input v-model="shopForm.gst_no"></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('shopProfile')" prop="shop_profile">
          <el-input type="textarea" autosize v-model="shopForm.business_profile"></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('uiTemplate')" prop="ui_template_id">
          <el-select
            v-model="shopForm.configs.ui_template_id"
            :placeholder="generateCustomizeString('selectUiTemplate')"
            style="width:200px"
            clearable
          >
            <el-option
              v-for="item in templateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('customerMustBindEmailOrPhone')">
          <el-switch v-model="isRequireEmailOrPhoneBound"></el-switch>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('onlyShowBenchmarkCurrency')">
          <el-switch v-model="shopForm.configs.only_show_benchmark_currency"></el-switch>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('allowPickUp')">
          <el-switch v-model="shopForm.configs.is_show_pick_up"></el-switch>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('allowShipping')">
          <el-switch v-model="shopForm.configs.is_show_receiving_address"></el-switch>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('isShowSender')">
          <el-switch v-model="shopForm.configs.is_show_sender_address"></el-switch>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('isShowCourierWeight')">
          <el-switch v-model="shopForm.configs.is_show_courier_weight"></el-switch>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('isAgeRestriction')">
          <el-switch v-model="shopForm.configs.is_age_restriction"></el-switch>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('businessScope')">
          <el-radio v-model="shopForm.configs.business_scope" label="International">{{ generateCustomizeString('International') }}</el-radio>
          <el-radio v-model="shopForm.configs.business_scope" label="New Zealand">{{ generateCustomizeString('newZealand') }}</el-radio>
          <!-- <el-switch v-model="shopForm.configs.is_age_restriction" :active-text="generateCustomizeString('enable')" :inactive-text="generateCustomizeString('close')"></el-switch> -->
        </el-form-item>
        <el-form-item :label="generateCustomizeString('idRequired')">
          <el-switch v-model="shopForm.configs.is_require_id_card_number"></el-switch>
        </el-form-item>

        <el-form-item :label="generateCustomizeString('searchHotKey')" prop="search_hot_keys">
          <el-tag
            :key="index"
            v-for="(tag, index) in searchHotKeysList"
            closable
            :disable-transitions="false"
            @click="topClick(index)"
            @close="handleClose(tag)"
            style="cursor: pointer;">
            {{tag}}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ {{generateCustomizeString('addSearchHotKey')}}</el-button>
          <div class="hot-key-tip">{{generateCustomizeString('clickHotKey')}}</div>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item :title="generateCustomizeString('shopOtherInfoSetting')" name="6">
        <el-form-item :label="generateCustomizeString('merchantName')" prop="merchant_name">
          <el-input v-model="shopForm.merchant_name"></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('merchantAddress')" prop="merchant_address">
          <el-input v-model="shopForm.merchant_address"></el-input>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('merchantContactPhone')"
          prop="merchant_contact_phone"
        >
          <el-input v-model="shopForm.merchant_contact_phone"></el-input>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('merchantContactEmail')"
          prop="merchant_contact_email"
        >
          <el-input v-model="shopForm.merchant_contact_email"></el-input>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('merchantContactPerson')"
          prop="merchant_contact_person"
        >
          <el-input v-model="shopForm.merchant_contact_person"></el-input>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('accountManager')" prop="account_manager">
          <el-input v-model="shopForm.account_manager"></el-input>
        </el-form-item>
        <el-form-item
          :label="generateCustomizeString('accountManagerMobilePhone')"
          prop="account_manager_mobile_phone"
        >
          <el-input v-model="shopForm.account_manager_mobile_phone"></el-input>
        </el-form-item>
      </el-collapse-item>

      <el-collapse-item :title="generateCustomizeString('shopPlan')" name="7" v-if="shopForm.openShop && shopForm.openShop.MEMBER_PLAN">
        <el-form-item
          :label="generateCustomizeString('memberPlan')"
          prop="member_plan_id"
        >
          <el-input disabled :value="shopForm.openShop.MEMBER_PLAN.progress_choose_target.member_plan_name + ' - ' + formatPrice(shopForm.openShop.MEMBER_PLAN.progress_choose_target.member_plan_price)" style="width:300px"></el-input>
          <el-button plain @click="updateMemberPlanFormVisible = true" style="margin-left: 10px;">{{ generateCustomizeString('memberPlanApply') }}</el-button>
          <p>({{generateCustomizeString("memberPlanInfo")}})</p>
        </el-form-item>
        <el-dialog
          :title="generateCustomizeString('memberPlanApply')"
          :visible.sync="updateMemberPlanFormVisible"
        >
          <el-form>
            <el-form-item
              :label="generateCustomizeString('memberPlan')"
              prop="member_plan_id"
              :label-width="formLabelWidth"
            >
              <el-select
                v-model="memberPlanId"
                style="width:300px"
                clearable
              >
                <el-option
                  v-for="item in memberPlanData"
                  :key="item.member_plan_id"
                  :label="item.member_plan_name + ' - ' + formatPrice(item.member_plan_price)"
                  :value="item.member_plan_id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              @click="updateMemberPlanFormVisible = false"
            >{{generateCustomizeString('cancelPassword')}}</el-button>
            <el-button
              type="primary"
              @click="memberPlanApply"
            >{{generateCustomizeString('submitPassword')}}</el-button>
          </div>
        </el-dialog>
      </el-collapse-item>
    </el-collapse>

    <!-- <el-form-item
      :label="generateCustomizeString('shopDomain')"
      prop="shop_domain_prefix"
    >
      <el-input
        v-model="shopForm.shop_domain_prefix"
        style="width:300px"
        disabled
      ></el-input>
      <span>.nzmai.com</span>
    </el-form-item>-->

    <!-- <el-form-item
      :label="generateCustomizeString('shopType')"
      prop="shop_type"
    >
      <el-select
        v-model="shopForm.shop_type"
        :placeholder="generateCustomizeString('pleaseChooseShopType')"
        style="width:250px"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="generateCustomizeString(item.label)"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>-->

    <el-form-item :label="generateCustomizeString('shopActivity')" prop="activity" style="margin: 30px auto;">
      <el-switch
        v-model="shopActivity"
        :active-text="generateCustomizeString('shopReady')"
        :inactive-text="generateCustomizeString('shopWaitForReview')"
        disabled
      ></el-switch>
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        @click="submitForm('shopForm')"
        plain
      >{{generateCustomizeString('update')}}</el-button>
      <!-- <el-button v-else type="primary" @click="submitForm('shopForm')">{{generateCustomizeString('create')}}</el-button> -->
    </el-form-item>
  </el-form>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import { formatPrice } from '@/utils/index.js'

import midApikey from '@/assets/img/mid_apikey.png'

const defaultShop = {
  id: null,
  shop_admin_email: '',
  shop_admin_password: '',
  display_shop_name: '',
  // shop_domain_prefix: '',
  shop_custom_host: '',
  shop_type: '',
  shop_logo_url: '',
  shop_logo_qiniu_res_key: '',
  merchant_name: '',
  merchant_address: '',
  merchant_contact_phone: '',
  merchant_contact_email: '',
  merchant_contact_person: '',
  account_manager: '',
  account_manager_mobile_phone: '',
  district: '',
  business_profile: '',
  business_details_introduced: '',
  shop_payment_details: '',
  tong_url: '',
  yi_url: '',
  activity: '',
  employee: {
    email: '',
    password: ''
  },
  is_agent: '',
  my_pay_api_key: '',
  my_pay_mid: '',
  my_pay_return_url: '',
  my_pay_notify_url: '',
  offline_payment_details: '',
  wx_appid: '',
  wx_secret: '',
  gst_no: '',
  oa_token: '',
  wechat_id: '',
  wechat_message: '',
  configs: {
    oa_welcome_image: '',
    welcome_image_qiniu_res_key: '',
    shop_qr: '',
    shop_qr_res_key: '',
    only_show_benchmark_currency: false,
    is_require_id_card_number: false,
    is_require_email_bound: false,
    is_require_phone_bound: false,
    ui_template_id: '',
    is_show_pick_up: false,
    is_show_receiving_address: false,
    is_show_courier_weight: false,
    is_show_sender_address: false,
    is_age_restriction: false,
    business_scope: 'International',
    search_hot_keys: [],
    custom_host_status: 'Inactive'
  },
  openShop: null
}

export default {
  name: 'ShopDetail',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the new password'))
      } else {
        if (this.passwordForm.password_confirmation !== '') {
          this.$refs.passwordForm.validateField('password_confirmation')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the new password again'))
      } else if (value !== this.passwordForm.password) {
        callback(new Error("Two inputs don't match!"))
      } else {
        callback()
      }
    }
    return {
      midApikey: midApikey,
      activeNames: ['1'],
      shopForm: Object.assign({}, defaultShop),
      isRequireEmailOrPhoneBound: false,
      resetPasswordFormVisible: false,
      passwordForm: {
        old_password: '',
        password: '',
        password_confirmation: ''
      },
      formLabelWidth: '110px',
      options: [
        {
          value: 1,
          label: 'company'
        },
        {
          value: 2,
          label: 'personal'
        }
      ],
      qiniuData: {
        token: ''
      },
      fetchLoding: false,
      templateOptions: [
        {
          value: 1,
          label: 'Template 1'
        },
        {
          value: 2,
          label: 'Template 2'
        }
      ],
      inputVisible: false,
      inputValue: '',
      searchHotKeysList: [],
      memberPlanData: null,
      memberPlanId: null,
      updateMemberPlanFormVisible: false,
      rules: {
        shop_admin_email: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          },
          {
            min: 3,
            max: 128,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          },
          {
            type: 'email',
            message: this.generateCustomizeString('pleaseEnter')
          }
        ],
        shop_admin_password: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          },
          {
            min: 6,
            max: 128,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        display_shop_name: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        // shop_domain_prefix: [
        //   {
        //     required: true,
        //     message: '请输入店铺网址',
        //     trigger: 'blur'
        //   }
        // ],
        shop_type: [
          {
            // required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'change'
          }
        ],
        shop_logo_url: [
          {
            // required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        merchant_contact_phone: [
          {
            trigger: 'change'
          },
          {
            min: 8,
            max: 15,
            pattern: '^[0,1][1-9]',
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'change'
          }
        ],
        merchant_contact_email: [
          {
            type: 'email',
            message: this.generateCustomizeString('pleaseEnter')
          }
        ],
        account_manager_mobile_phone: [
          {
            trigger: 'change'
          },
          {
            min: 8,
            max: 15,
            pattern: '^[0,1][1-9]',
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'change'
          }
        ],
        old_password: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        password: [
          {
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        password_confirmation: [
          {
            validator: validatePass2,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    editStatus() {
      return this.isEdit === true
    },
    shopId() {
      return this.$route.params.shopId
    },
    displayLogoUrl() {
      return (
        this.shopForm.shop_logo_url + '?imageView2/0/w/360/h/180/q/75|imageslim'
      )
    },
    displayWelcomeImgUrl() {
      return (
        this.shopForm.configs.oa_welcome_image +
        '?imageView2/0/w/360/h/180/q/75|imageslim'
      )
    },
    displayShopQr() {
      return (
        this.shopForm.configs.shop_qr +
        '?imageView2/0/w/360/h/180/q/75|imageslim'
      )
    },
    shopActivity: {
      get: function() {
        return this.shopForm.activity === 1
      },
      set: function(newValue) {
        if (newValue) {
          this.shopForm.activity = 1
        } else {
          this.shopForm.activity = 0
        }
      }
    }
  },
  methods: {
    formatPrice,
    generateCustomizeString,
    submitForm(formName) {
      this.updateShop()
    },
    createShop() {
      if (this.shopForm.configs.is_show_pick_up === false && this.shopForm.configs.is_show_receiving_address === false) {
        this.$message({
          message: this.generateCustomizeString('pickUpOrShipping'),
          type: 'warning'
        })
        return
      }
      var data = {
        shop_admin_email: this.shopForm.shop_admin_email,
        shop_admin_password: this.shopForm.shop_admin_password,
        display_shop_name: this.shopForm.display_shop_name,
        shop_custom_host: this.shopForm.shop_custom_host,
        // shop_domain_prefix: this.shopForm.shop_domain_prefix,
        shop_type: this.shopForm.shop_type,
        shop_logo_qiniu_res_key: this.shopForm.shop_logo_qiniu_res_key,
        merchant_name: this.shopForm.merchant_name,
        merchant_address: this.shopForm.merchant_address,
        merchant_contact_phone: this.shopForm.merchant_contact_phone,
        merchant_contact_email: this.shopForm.merchant_contact_email,
        merchant_contact_person: this.shopForm.merchant_contact_person,
        account_manager: this.shopForm.account_manager,
        account_manager_mobile_phone: this.shopForm
          .account_manager_mobile_phone,
        district: this.shopForm.district,
        business_profile: this.shopForm.business_profile,
        business_details_introduced: this.shopForm.business_details_introduced,
        activity: this.shopForm.activity,
        my_pay_mid: this.shopForm.my_pay_mid,
        my_pay_api_key: this.shopForm.my_pay_api_key,
        my_pay_return_url: this.shopForm.my_pay_return_url,
        my_pay_notify_url: this.shopForm.my_pay_notify_url,
        offline_payment_details: this.shopForm.offline_payment_details,
        wx_appid: this.shopForm.wx_appid,
        wx_secret: this.shopForm.wx_secret,
        gst_no: this.shopForm.gst_no,
        wechat_id: this.shopForm.wechat_id,
        wechat_message: this.shopForm.wechat_message
      }
      data['configs'] = {
        oa_welcome_image: this.shopForm.configs.oa_welcome_image,
        shop_qr: this.shopForm.configs.shop_qr,
        is_require_email_bound: this.isRequireEmailOrPhoneBound,
        is_require_phone_bound: this.isRequireEmailOrPhoneBound,
        is_show_pick_up: this.shopForm.configs.is_show_pick_up,
        is_show_receiving_address: this.shopForm.configs.is_show_receiving_address,
        is_show_courier_weight: this.shopForm.configs.is_show_courier_weight,
        is_show_sender_address: this.shopForm.configs.is_show_sender_address,
        is_age_restriction: this.shopForm.configs.is_age_restriction,
        business_scope: this.shopForm.configs.business_scope,
        search_hot_keys: this.searchHotKeysList
      }
      request({
        url: '',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('createdSuccessfully'),
              type: 'success'
            })

            this.$router.replace({ name: 'Shop' })
          } else {
            this.$message.error(this.generateCustomizeString('createFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('createFailed'))
        })
    },
    updateSubmit(formName) {
      this.updateShop()
    },
    fetchShop() {
      if (this.fetchLoding) return
      this.fetchLoding = true

      request({
        url: 'basic',
        method: 'get'
      })
        .then(res => {
          if (res.status === 0) {
            // console.log(res.data)
            for (const i in this.shopForm) {
              if (i === 'employee') {
                console.log(res.data['employees'])
                var employee = res.data['employees'][0]
                this.shopForm.employee.email = employee.email
                this.shopForm.employee.password = '****************'
                continue
              }
              this.shopForm[i] = res.data[i]
              if (res.data['configs']['search_hot_keys'] == null) {
                this.searchHotKeysList = []
              } else {
                this.searchHotKeysList = res.data['configs']['search_hot_keys']
              }
            }
            this.isRequireEmailOrPhoneBound = !!(
              this.shopForm.configs.is_require_email_bound &&
              this.shopForm.configs.is_require_phone_bound
            )
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.fetchLoding = false
        })
    },
    updateShop() {
      if (this.shopForm.configs.is_show_pick_up === false && this.shopForm.configs.is_show_receiving_address === false) {
        this.$message({
          message: this.generateCustomizeString('pickUpOrShipping'),
          type: 'warning'
        })
        return
      }
      var data = {
        display_shop_name: this.shopForm.display_shop_name,
        // shop_domain_prefix: this.shopForm.shop_domain_prefix,
        shop_custom_host: this.shopForm.shop_custom_host,
        shop_type: this.shopForm.shop_type,
        shop_logo_qiniu_res_key: this.shopForm.shop_logo_qiniu_res_key,
        merchant_name: this.shopForm.merchant_name,
        merchant_address: this.shopForm.merchant_address,
        merchant_contact_phone: this.shopForm.merchant_contact_phone,
        merchant_contact_email: this.shopForm.merchant_contact_email,
        merchant_contact_person: this.shopForm.merchant_contact_person,
        account_manager: this.shopForm.account_manager,
        account_manager_mobile_phone: this.shopForm
          .account_manager_mobile_phone,
        district: this.shopForm.district,
        business_profile: this.shopForm.business_profile,
        business_details_introduced: this.shopForm.business_details_introduced,
        activity: this.shopForm.activity,
        my_pay_mid: this.shopForm.my_pay_mid,
        my_pay_api_key: this.shopForm.my_pay_api_key,
        my_pay_return_url: this.shopForm.my_pay_return_url,
        my_pay_notify_url: this.shopForm.my_pay_notify_url,
        offline_payment_details: this.shopForm.offline_payment_details,
        wx_appid: this.shopForm.wx_appid,
        wx_secret: this.shopForm.wx_secret,
        oa_token: this.shopForm.oa_token,
        gst_no: this.shopForm.gst_no,
        wechat_id: this.shopForm.wechat_id,
        wechat_message: this.shopForm.wechat_message
      }
      data['configs'] = {
        oa_welcome_image: this.shopForm.configs.oa_welcome_image,
        shop_qr: this.shopForm.configs.shop_qr,
        is_require_email_bound: this.isRequireEmailOrPhoneBound,
        is_require_phone_bound: this.isRequireEmailOrPhoneBound,
        is_require_id_card_number: this.shopForm.configs
          .is_require_id_card_number,
        only_show_benchmark_currency: this.shopForm.configs
          .only_show_benchmark_currency,
        ui_template_id: this.shopForm.configs.ui_template_id,
        is_show_pick_up: this.shopForm.configs.is_show_pick_up,
        is_show_receiving_address: this.shopForm.configs.is_show_receiving_address,
        is_show_courier_weight: this.shopForm.configs.is_show_courier_weight,
        is_show_sender_address: this.shopForm.configs.is_show_sender_address,
        is_age_restriction: this.shopForm.configs.is_age_restriction,
        business_scope: this.shopForm.configs.business_scope,
        search_hot_keys: this.searchHotKeysList,
        custom_host_status: this.shopForm.configs.custom_host_status
      }
      request({
        url: 'basic',
        method: 'patch',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
    },
    resetPasswordAction() {
      var data = {
        old_password: this.passwordForm.old_password,
        password: this.passwordForm.password,
        password_confirmation: this.passwordForm.password_confirmation
      }
      request({
        url: '/admin/me/password',
        method: 'put',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
            this.passwordForm.old_password = ''
            this.passwordForm.password = ''
            this.passwordForm.password_confirmation = ''
          } else {
            this.$message.error(this.generateCustomizeString('updateFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
        .finally(() => {
          this.resetPasswordFormVisible = false
        })
    },
    fetchUploadToken() {
      request({
        url: '/upload-token',
        method: 'get'
      })
        .then(res => {
          this.qiniuData.token = res.data['token']
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleAvatarSuccess(res, file) {
      // 上传成功后在图片框显示图片
      // 更改了key
      this.shopForm.shop_logo_qiniu_res_key = res.key

      this.shopForm.shop_logo_url = 'https://img.nzmai.com.cn/' + res.key
    },
    handleOaWelcomeAvatarSuccess(res, file) {
      // 上传成功后在图片框显示图片
      // 更改了key
      this.shopForm.configs.welcome_image_qiniu_res_key = res.key
      this.shopForm.configs.oa_welcome_image =
        'https://img.nzmai.com.cn/' + res.key
      // this.shopForm['configs'] = { 'welcome_image_qiniu_res_key': res.key }
      // this.shopForm['configs'] = { 'oa_welcome_image': 'https://img.nzmai.com.cn/' + res.key }
      console.log(res)
    },
    handleShopQr(res, file) {
      this.shopForm.configs.shop_qr_res_key = res.key
      this.shopForm.configs.shop_qr = 'https://img.nzmai.com.cn/' + res.key
      // this.shopForm['configs'] = { 'shop_qr_res_key': res.key }
      // this.shopForm['configs'] = { 'shop_qr': 'https://img.nzmai.com.cn/' + res.key }
      console.log(res)
    },
    handleError(res) {
      // 显示错误
      console.log(res)
    },
    beforeAvatarUpload(file) {
      // 在图片提交前进行验证
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error(this.generateCustomizeString('jpgpngonly'))
      }
      if (!isLt2M) {
        this.$message.error(this.generateCustomizeString('lessThan2MB'))
      }

      return (isJPG || isPNG) && isLt2M
    },
    handleClose(tag) {
      this.searchHotKeysList.splice(this.searchHotKeysList.indexOf(tag), 1)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      const inputValue = this.inputValue
      if (inputValue) {
        this.searchHotKeysList.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    topClick(index) {
      this.searchHotKeysList.unshift(this.searchHotKeysList.splice(index, 1)[0])
    },
    fetchMemberPlanData() {
      request({
        url: 'member-plan/list',
        method: 'get'
      }).then(res => {
        this.memberPlanData = res.data
      })
    },
    memberPlanApply() {
      const oldMemberPlanId = (this.shopForm.openShop && this.shopForm.openShop.MEMBER_PLAN) ? this.shopForm.openShop.MEMBER_PLAN.progress_choose_target.member_plan_id : 0
      var data = {
        shop_id: this.shopForm.id,
        old_member_plan_id: oldMemberPlanId,
        new_member_plan_id: this.memberPlanId
      }
      request({
        url: 'member-plan/apply',
        method: 'post',
        data
      })
        .then((res) => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('applySuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('applyFailed'))
          }
        })
        .catch((error) => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('applyFailed'))
        })
        .finally(() => {
          this.updateMemberPlanFormVisible = false
        })
    }
  },
  created() {
    this.fetchUploadToken()
    this.fetchShop()
    if (this.$route.params.activeName) {
      this.activeNames = []
      this.activeNames.push(this.$route.params.activeName)
    }
    this.fetchMemberPlanData()
  },
  activated() {
    if (this.$route.params.activeName) {
      this.activeNames = []
      this.activeNames.push(this.$route.params.activeName)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.shop-detail-form {
  padding: 50px 60px 0px 40px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.hot-key-tip {
  margin-bottom: -20px;
  font-size: 12px;
  color: #606266;
}
.payment-setting-tips {
  padding: 10px;
  word-break : normal;
}
.custom-host-status {
  margin-left: 10px;
  padding: 0 15px;
  font-size: 14px;
  line-height: 40px;
  height: 40px;
}
</style>
<style type="text/css">
  .shop-detail-form .el-collapse-item__wrap {
    padding-top: 20px;
  }

 .shop-detail-form .el-collapse-item__header {
  color: #15c !important;
}
</style>
